import { Quicklink } from 'models';

const preConfiguredQuicklinks: Record<string, Quicklink[]> = {
  abritel: [
    {
      name: 'abritel-home',
      title: 'Abritel FR Homepage',
      link: 'https://www.abritel.fr/',
      text: 'Trouvez la location de vacances de vos rêves sur Abritel',
    },
    {
      name: 'france',
      title: 'France',
      link: 'https://www.abritel.fr/d/33814/france',
      text: 'Trouvez des locations de vacances en France sur Abritel',
    },
    {
      name: 'normandie',
      title: 'Normandie',
      link: 'https://www.abritel.fr/d/24796/normandie',
      text: 'Trouvez des locations de vacances en Normandie sur Abritel',
    },
    {
      name: 'bretagne',
      title: 'Bretagne',
      link: 'https://www.abritel.fr/d/44887/bretagne',
      text: 'Trouvez des locations de vacances en Bretagne sur Abritel',
    },
    {
      name: 'corse',
      title: 'Corse',
      link: 'https://www.abritel.fr/d/20806/corse',
      text: 'Trouvez des locations de vacances en Corse sur Abritel',
    },
    {
      name: 'maison-avec-piscine',
      title: 'Locations de vacances avec piscine',
      link: 'https://www.abritel.fr/sejours/maison-avec-piscine',
      text: 'Trouver des locations de vacances avec piscine sur Abritel',
    },
    {
      name: 'maison-avec-jacuzzi',
      title: 'Maisons avec jacuzzi',
      link: 'https://www.abritel.fr/sejours/maison-avec-jacuzzi',
      text: 'Trouver des locations de vacances avec jacuzzi sur Abritel',
    },
    {
      name: 'gorges-du-verdon',
      title: 'Gorges du Verdon',
      link: 'https://www.abritel.fr/d/347883/gorges-du-verdon',
      text: 'Trouver des locations de vacances Gorges du Verdon sur Abritel',
    },
    {
      name: 'provence-alpes-cote-dazur',
      title: "Provence-Alpes-Côte d'Azur",
      link: 'https://www.abritel.fr/d/5648/provence-alpes-cote-dazur',
      text: "Trouvez des locations de vacances en Provence-Alpes-Côte d'Azur sur Abritel",
    },
    {
      name: 'ile-de-re',
      title: 'Île de Ré',
      link: 'https://www.abritel.fr/d/3239/ile-de-re',
      text: "Trouvez des locations de vacances sur l'île de Ré sur Abritel",
    },
  ],
  'au-stayz': [
    {
      name: 'stayz-home',
      title: 'Stayz AU Homepage',
      link: 'https://www.stayz.com.au/',
      text: 'Find your dream vacation rental on Stayz',
    },
    {
      name: 'australia',
      title: 'Australia',
      link: 'https://www.stayz.com.au/d/11278/australia',
      text: 'Find Australia vacation rentals on Stayz',
    },
    {
      name: 'gold-coast',
      title: 'Gold Coast',
      link: 'https://www.stayz.com.au/d/48329/gold-coast',
      text: 'Find Gold Coast vacation rentals on Stayz',
    },
    {
      name: 'new-south-wales',
      title: 'New South Wales',
      link: 'https://www.stayz.com.au/travel/campaign/meso-dnsw',
      text: 'Find New South Wales vacation rentals on Stayz',
    },
    {
      name: 'sunshine-coast',
      title: 'Sunshine Coast',
      link: 'https://www.stayz.com.au/d/777/sunshine-coast',
      text: 'Find Sunshine Coast vacation rentals on Stayz',
    },
    {
      name: 'sydney',
      title: 'Sydney',
      link: 'https://www.stayz.com.au/d/404865/sydney',
      text: 'Find Sydney vacation rentals on Stayz',
    },
    {
      name: 'pet-friendly',
      title: 'Pet Friendly',
      link: 'https://www.stayz.com.au/travel/pet-friendly',
      text: 'Find Pet Friendly vacation rentals on Stayz',
    },
    {
      name: 'party-houses',
      title: 'Party Houses',
      link: 'https://www.stayz.com.au/d/737450/party-house',
      text: 'Find Party Houses vacation rentals on Stayz',
    },
    {
      name: 'mornington-peninsula',
      title: 'Mornington Peninsula',
      link: 'https://www.stayz.com.au/d/16726/mornington-peninsula',
      text: 'Find Mornington Peninsula vacation rentals on Stayz',
    },
    {
      name: 'victoria',
      title: 'Victoria',
      link: 'https://www.stayz.com.au/d/14199/victoria',
      text: 'Find Victoria vacation rentals on Stayz',
    },
  ],
  'ca-hcom': [
    {
      name: 'hcom-home',
      title: 'Hotels.com Canada Homepage',
      link: 'https://ca.hotels.com/',
      text: 'Find your dream accommodation on Hotels.com',
    },
    {
      name: 'vancouver',
      title: 'Vancouver',
      link: 'https://ca.hotels.com/de169712/vancouver-british-columbia-hotels-rooms/',
      text: 'Find Vancouver accommodation on Hotels.com',
    },
    {
      name: 'banff',
      title: 'Banff',
      link: 'https://ca.hotels.com/de170124/banff-alberta-hotels-rooms/',
      text: 'Find Banff accommodation on Hotels.com',
    },
    {
      name: 'toronto',
      title: 'Toronto',
      link: 'https://ca.hotels.com/de1636865/toronto-ontario-hotels-rooms/',
      text: 'Find Toronto accommodation on Hotels.com',
    },
    {
      name: 'edmonton',
      title: 'Edmonton',
      link: 'https://ca.hotels.com/de167228/edmonton-alberta-hotels-rooms/',
      text: 'Find Edmonton accommodation on Hotels.com',
    },
    {
      name: 'okanagan-valley',
      title: 'Okanagan Valley',
      link: 'https://ca.hotels.com/re1643884/hotels-in-okanagan-valley-canada/',
      text: 'Find Okanagan Valley accommodation on Hotels.com',
    },
    {
      name: 'calgary',
      title: 'Calgary',
      link: 'https://ca.hotels.com/de169003/calgary-alberta-hotels-rooms/',
      text: 'Find Calgary accommodation on Hotels.com',
    },
    {
      name: 'montreal',
      title: 'Montreal',
      link: 'https://ca.hotels.com/de169716/montreal-quebec-hotels-rooms/',
      text: 'Find Montreal accommodation on Hotels.com',
    },
    {
      name: 'free-cancellation-deals',
      title: 'Free cancellation deals',
      link: 'https://ca.hotels.com/hotel-deals/freecanc/',
      text: 'Find free cancellation deals on Hotels.com',
    },
    {
      name: 'budget-friendly-deals',
      title: 'Budget-friendly deals',
      link: 'https://ca.hotels.com/hotel-deals/budgetfriendly/',
      text: 'Find budget-friendly deals on Hotels.com',
    },
  ],
  'ca-vrbo': [
    {
      name: 'vrbo-home',
      title: 'Vrbo CA Homepage',
      link: 'https://www.vrbo.com/en-ca/',
      text: 'Find your dream vacation rental on Vrbo',
    },
    {
      name: 'canada',
      title: 'Canada',
      link: 'https://www.vrbo.com/en-ca/vacation-rentals/canada',
      text: 'Find Canada vacation rentals on Vrbo',
    },
    {
      name: 'ontario',
      title: 'Ontario',
      link: 'https://www.vrbo.com/en-ca/vacation-rentals/canada/ontario',
      text: 'Find Ontario vacation rentals on Vrbo',
    },
    {
      name: 'kelowna',
      title: 'Kelowna',
      link: 'https://www.vrbo.com/en-ca/vacation-rentals/canada/british-columbia/central-okanagan/kelowna',
      text: 'Find Kelowna vacation rentals on Vrbo',
    },
    {
      name: 'british-columbia',
      title: 'British Columbia',
      link: 'https://www.vrbo.com/en-ca/vacation-rentals/canada/british-columbia',
      text: 'Find British Columbia vacation rentals on Vrbo',
    },
    {
      name: 'maui',
      title: 'Maui',
      link: 'https://www.vrbo.com/en-ca/vacation-rentals/united-states/hawaii/maui',
      text: 'Find Maui vacation rentals on Vrbo',
    },
    {
      name: 'canmore',
      title: 'Canmore',
      link: 'https://www.vrbo.com/en-ca/vacation-rentals/canada/alberta/canmore',
      text: 'Find Canmore vacation rentals on Vrbo',
    },
    {
      name: 'vancouver',
      title: 'Vancouver',
      link: 'https://www.vrbo.com/en-ca/vacation-rentals/canada/british-columbia/greater-vancouver/vancouver',
      text: 'Find Vancouver vacation rentals on Vrbo',
    },
    {
      name: 'florida',
      title: 'Florida',
      link: 'https://www.vrbo.com/en-ca/vacation-rentals/united-states/florida',
      text: 'Find Florida vacation rentals on Vrbo',
    },
    {
      name: 'prince-edward-island',
      title: 'Prince Edward Island',
      link: 'https://www.vrbo.com/en-ca/vacation-rentals/canada/prince-edward-island',
      text: 'Find Prince Edward Island vacation rentals on Vrbo',
    },
  ],
  'fewo-direkt': [
    {
      name: 'fewodirekt-home',
      title: 'FeWo-direkt DE Homepage',
      link: 'https://www.fewo-direkt.de/',
      text: 'Finden Sie Ihre Traumferienwohnung auf FeWo-direkt',
    },
    {
      name: 'ostsee',
      title: 'Ostsee',
      link: 'https://www.fewo-direkt.de/d/287117/ostsee',
      text: 'Ostsee-Ferienwohnungen finden auf FeWo-direkt',
    },
    {
      name: 'nordsee',
      title: 'Nordsee',
      link: 'https://www.fewo-direkt.de/d/276604/nordsee',
      text: 'Nordsee-Ferienwohnungen auf FeWo-direkt finden',
    },
    {
      name: 'deutschland',
      title: 'Deutschland',
      link: 'https://www.fewo-direkt.de/d/30695/deutschland',
      text: 'Ferienwohnungen in Deutschland auf FeWo-direkt finden',
    },
    {
      name: 'gardasee',
      title: 'Gardasee',
      link: 'https://www.fewo-direkt.de/d/91340/gardasee',
      text: 'Ferienwohnungen am Gardasee finden auf FeWo-direkt',
    },
    {
      name: 'bodensee',
      title: 'Bodensee',
      link: 'https://www.fewo-direkt.de/d/58868/bodensee',
      text: 'Ferienwohnungen Bodensee auf FeWo-direkt finden',
    },
    {
      name: 'allgau',
      title: 'Allgäu',
      link: 'https://www.fewo-direkt.de/d/49644/allgau',
      text: 'Ferienwohnungen im Allgäu auf FeWo-direkt finden',
    },
    {
      name: 'eibsee',
      title: 'Eibsee',
      link: 'https://www.fewo-direkt.de/d/73436/eibsee',
      text: 'Eibsee-Ferienwohnungen auf FeWo-direkt finden',
    },
    {
      name: 'whirpool',
      title: 'Feriendomizile mit Whirlpool',
      link: 'https://www.fewo-direkt.de/reisen/whirlpool',
      text: 'Ferienhäuser mit Whirlpool auf FeWo-direkt finden',
    },
    {
      name: 'norddeich',
      title: 'Norddeich',
      link: 'https://www.fewo-direkt.de/d/34258/norddeich',
      text: 'Ferienwohnungen Norddeich auf FeWo-direkt finden',
    },
  ],
  'uk-hcom': [
    {
      name: 'hcom-home',
      title: 'Hotels.com UK Homepage',
      link: 'https://uk.hotels.com/',
      text: 'Find your dream accommodation on Hotels.com',
    },
    {
      name: 'london',
      title: 'London',
      link: 'https://uk.hotels.com/de549499/hotels-london-united-kingdom/',
      text: 'Find London accommodation on Hotels.com',
    },
    {
      name: 'dubai',
      title: 'Dubai',
      link: 'https://uk.hotels.com/de11594/hotels-dubai-united-arab-emirates/',
      text: 'Find Dubai accommodation on Hotels.com',
    },
    {
      name: 'manchester',
      title: 'Manchester',
      link: 'https://uk.hotels.com/de544578/hotels-manchester-united-kingdom/',
      text: 'Find Manchester accommodation on Hotels.com',
    },
    {
      name: 'devon',
      title: 'Devon',
      link: 'https://uk.hotels.com/de1641724/hotels-devon-county-united-kingdom/',
      text: 'Find Devon accommodation on Hotels.com',
    },
    {
      name: 'hampshire',
      title: 'Hampshire',
      link: 'https://uk.hotels.com/de1641735/hotels-hampshire-county-united-kingdom/',
      text: 'Find Hampshire accommodation on Hotels.com',
    },
    {
      name: 'yorkshire',
      title: 'Yorkshire',
      link: 'https://uk.hotels.com/re10248460/hotels-in-yorkshire-united-kingdom/',
      text: 'Find Yorkshire accommodation on Hotels.com',
    },
    {
      name: 'edinburgh',
      title: 'Edinburgh',
      link: 'https://uk.hotels.com/de554344/hotels-edinburgh-united-kingdom/',
      text: 'Find Edinburgh accommodation on Hotels.com',
    },
    {
      name: 'free-cancellation-deals',
      title: 'Free cancellation deals',
      link: 'https://uk.hotels.com/hotel-deals/freecanc/',
      text: 'Find free cancellation deals on Hotels.com',
    },
    {
      name: 'budget-friendly-deals',
      title: 'Budget-friendly deals',
      link: 'https://uk.hotels.com/hotel-deals/budgetfriendly/',
      text: 'Find budget-friendly deals on Hotels.com',
    },
  ],
  'uk-vrbo': [
    {
      name: 'vrbo-home',
      title: 'Vrbo UK Homepage',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom',
      text: 'Find your dream vacation rental on Vrbo',
    },
    {
      name: 'england',
      title: 'England',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/england',
      text: 'Find England vacation rentals on Vrbo',
    },
    {
      name: 'spain',
      title: 'Spain',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/spain',
      text: 'Find Spain vacation rentals on Vrbo',
    },
    {
      name: 'scotland',
      title: 'Scotland',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/scotland',
      text: 'Find Scotland vacation rentals on Vrbo',
    },
    {
      name: 'hot-tub-breaks',
      title: 'Hot tub breaks',
      link: 'https://www.vrbo.com/en-gb/travel/hot-tub-breaks',
      text: 'Find Hot tub breaks on Vrbo',
    },
    {
      name: 'cornwall',
      title: 'Cornwall',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/england/cornwall',
      text: 'Find Cornwall vacation rentals on Vrbo',
    },
    {
      name: 'france',
      title: 'France',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/france',
      text: 'Find France vacation rentals on Vrbo',
    },
    {
      name: 'london',
      title: 'London',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/england/greater-london/london',
      text: 'Find London vacation rentals on Vrbo',
    },
    {
      name: 'wales',
      title: 'Wales',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/wales',
      text: 'Find Wales vacation rentals on Vrbo',
    },
    {
      name: 'florida',
      title: 'Florida',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-states/florida',
      text: 'Find Florida vacation rentals on Vrbo',
    },
  ],
  'us-hcom': [
    {
      name: 'hcom-home',
      title: 'Hotels.com USA Homepage',
      link: 'https://www.hotels.com/?pos=HCOM_US&locale=en_US',
      text: 'Find your dream accommodation on Hotels.com',
    },
    {
      name: 'las-vegas',
      title: 'Las Vegas',
      link: 'https://www.hotels.com/de1504033/hotels-las-vegas-nevada?pos=HCOM_US&locale=en_US',
      text: 'Find Las Vegas accommodations on Hotels.com',
    },
    {
      name: 'orlando',
      title: 'Orlando',
      link: 'https://www.hotels.com/de1404711/hotels-orlando-florida?pos=HCOM_US&locale=en_US',
      text: 'Find Orlando accommodations on Hotels.com',
    },
    {
      name: 'los-angeles',
      title: 'Los Angeles',
      link: 'https://www.hotels.com/de1439028/hotels-los-angeles-california?pos=HCOM_US&locale=en_US',
      text: 'Find Los Angeles accommodations on Hotels.com',
    },
    {
      name: 'miami',
      title: 'Miami',
      link: 'https://www.hotels.com/de1516192/hotels-miami-florida?pos=HCOM_US&locale=en_US',
      text: 'Find Miami accommodations on Hotels.com',
    },
    {
      name: 'san-diego',
      title: 'San Diego',
      link: 'https://www.hotels.com/de1483250/hotels-san-diego-california?pos=HCOM_US&locale=en_US',
      text: 'Find San Diego accommodations on Hotels.com',
    },
    {
      name: 'dallas',
      title: 'Dallas',
      link: 'https://www.hotels.com/de1486134/hotels-dallas-texas?pos=HCOM_US&locale=en_US',
      text: 'Find Dallas accommodations on Hotels.com',
    },
    {
      name: 'road-trips',
      title: 'Road trips',
      link: 'https://www.hotels.com/page/roadtrips?pos=HCOM_US&locale=en_US',
      text: 'Find great American road trips on Hotels.com',
    },
    {
      name: 'nature-deals',
      title: 'Nature deals',
      link: 'https://www.hotels.com/hotel-deals/ss001-nature?pos=HCOM_US&locale=en_US',
      text: 'Save on your next trip to the great outdoors on Hotels.com',
    },
    {
      name: 'budget-friendly-deals',
      title: 'Budget-friendly deals',
      link: 'https://www.hotels.com/hotel-deals/budgetfriendly?pos=HCOM_US&locale=en_US',
      text: 'Find budget-friendly deals on Hotels.com',
    },
  ],
  'us-vrbo': [
    {
      name: 'vrbo-home',
      title: 'Vrbo US Homepage',
      link: 'https://www.vrbo.com/',
      text: 'Find your dream vacation rental on Vrbo',
    },
    {
      name: 'vacation-rentals',
      title: 'Vacation rentals',
      link: 'https://www.vrbo.com/vacation-rentals',
      text: 'Search vacation rentals on Vrbo',
    },
    {
      name: 'staycations',
      title: 'Staycations (road trips)',
      link: 'https://www.vrbo.com/travel/staycation',
      text: 'Find a great road trip on Vrbo',
    },
    {
      name: 'florida',
      title: 'Florida',
      link: 'https://www.vrbo.com/vacation-rentals/usa/florida',
      text: 'Find Florida vacation rentals on Vrbo',
    },
    {
      name: 'destin',
      title: 'Destin',
      link: 'https://www.vrbo.com/vacation-rentals/usa/florida/north-west/destin',
      text: 'Find Destin vacation rentals on Vrbo',
    },
    {
      name: 'panama-city-beach',
      title: 'Panama City Beach',
      link: 'https://www.vrbo.com/vacation-rentals/usa/florida/north-west/panama-city-beach',
      text: 'Find Panama City Beach vacation rentals on Vrbo',
    },
    {
      name: 'gulf-shores',
      title: 'Gulf Shores',
      link: 'https://www.vrbo.com/vacation-rentals/usa/alabama/gulf-shores',
      text: 'Find Gulf Shores vacation rentals on Vrbo',
    },
    {
      name: 'hilton-head-island',
      title: 'Hilton Head Island',
      link: 'https://www.vrbo.com/vacation-rentals/usa/south-carolina/hilton-head-island',
      text: 'Find Hilton Head Island vacation rentals on Vrbo',
    },
    {
      name: 'gatlinburg',
      title: 'Gatlinburg',
      link: 'https://www.vrbo.com/vacation-rentals/usa/tennessee/east/gatlinburg',
      text: 'Find Gatlinburg vacation rentals on Vrbo',
    },
    {
      name: 'key-west',
      title: 'Key West',
      link: 'https://www.vrbo.com/vacation-rentals/usa/florida/keys/key-west-area/key-west',
      text: 'Find Key West vacation rentals on Vrbo',
    },
  ],
};

export { preConfiguredQuicklinks };
